/**
 * Created by razial on 20.08.2025.
 */

Placements.ENTRIES["unknownLocationAlert"] = {
    type: Placements.FREE_FOCUS,
    priority: 1000,
    filter: function () {
        if (cleverapps.config.name === "garden") {
            const locationMeta = cleverapps.meta.getLocationMeta(cleverapps.meta.selectedLocationId());
            return locationMeta.isUnknown() && !cleverapps.config.adminMode;
        }
    },

    action: function () {
        cleverapps.focusManager.display({
            focus: "UnknownLocationAlert",
            action: function (f) {
                cleverapps.playSession.logEvent(cleverapps.EVENTS.LOCATION.UNKNOWN_OPENED);
                cleverapps.playSession.logEventOnce(cleverapps.EVENTS.LOCATION.UNKNOWN_OPENED_DAU);

                cleverapps.newVersionChecker.showUpgradeWindow(f, NewVersionChecker.TRIGGER_UNKNOWN_LOCATION);
            }
        });
    }
};

Placements.ENTRIES["useSingleLocationMigrationNotice"] = {
    type: Placements.FREE_FOCUS,
    priority: 1000,
    filter: function () {
        return cleverapps.dataVersion.useSingleLocationMigrationNotice;
    },

    action: function () {
        cleverapps.focusManager.display({
            focus: "gardenMigrationNotice",
            action: function (f) {
                cleverapps.dataVersion.useSingleLocationMigrationNotice = false;

                new MigrationNoticeWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};

Placements.ENTRIES["softConversionAlert"] = {
    type: Placements.FREE_FOCUS,
    priority: 1000,
    filter: function () {
        return cleverapps.dataVersion.hardConversionData;
    },

    action: function () {
        cleverapps.focusManager.display({
            focus: "softConversionAlert",
            action: function (f) {
                const data = cleverapps.dataVersion.hardConversionData;
                delete cleverapps.dataVersion.hardConversionData;

                new SoftConversionWindow(data);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};